/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef} from 'react'

/**
 * @public
 */
export const ShareIcon = forwardRef(function ShareIcon(
  props: React.SVGProps<SVGSVGElement>,
  ref: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      data-sanity-icon="share"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        d="M15 10.5H18.5V19.5H6.5L6.5 10.5H10M12.5 16V3.5"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinejoin="round"
      />
      <path d="M9 7L12.5 3.5L16 7" stroke="currentColor" strokeWidth={1.2} strokeLinejoin="round" />
    </svg>
  )
})
ShareIcon.displayName = 'ForwardRef(ShareIcon)'
